import { render, staticRenderFns } from "./atomizingWire.vue?vue&type=template&id=90cefc88&"
import script from "./atomizingWire.vue?vue&type=script&lang=js&"
export * from "./atomizingWire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90cefc88')) {
      api.createRecord('90cefc88', component.options)
    } else {
      api.reload('90cefc88', component.options)
    }
    module.hot.accept("./atomizingWire.vue?vue&type=template&id=90cefc88&", function () {
      api.rerender('90cefc88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/atomizing-wire/atomizingWire.vue"
export default component.exports